import React, {useEffect, useRef, Fragment} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import LookWizardContentButtons from "./lookWizardContentButtons";
import {
  disableNotSelectedFeatureGroups,
  getCurrentGroups,
  getFeatureGroupFromWizardGroup, getNextWizardStepQuantity,
  useHideItemsDisabledfeatureGroups
} from "./lookWizardFunctions";
import LookWizardContentCanvas from "./lookWizardContentCanvas";
import PropTypes from "prop-types";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import LookFeatureOptions from "../lookFeature/lookFeatureOptions";
import LookWizardCompletedAlertModal from "./lookWizardCompletedAlertModal";
import LookWizardContentFinalPrice from "./lookWizardContentFinalPrice";
import LookWizardContentTitle from "./lookWizardContentTitle";
import LookWizardContentDescription from "./lookWizardContentDescription";
// import LookWizardContentMatch from "./lookWizardContentMatch";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import GroheFeatureOptions from "../../../grohe/groheNavigation/groheFeature/groheFeatureOptions";
import {setLookActiveFeature} from "../../../../../actions/lookFunctions";
import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";
import {isInStock} from "../../lookFunctions2";
import GroheFeatureSoldOut from "../../../grohe/groheNavigation/groheFeature/groheFeatureSoldOut";
import {useUpdateMatchAllButton} from "../../../../../misc/helperHooks";


const LookWizardContent = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, updateLookCartItem, isMobile, imageCanvas,
    setLookActiveFeature, setGroheActiveFeatureQuantity, visualizersLoadedLength} = props;
  // const {customImageUrl, uploadedImageUrl} = wizardActiveItem;
  const thumbnailRef = useRef();

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  let featureGroup = null;

  if (currentGroups.length === 1 && currentGroups[0].nodeType === "group") {
    featureGroup = getFeatureGroupFromWizardGroup(currentGroups[0]);
  }

  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  useEffect(() => {
    if (isCompletedStep && wizardActiveItem.hideItems) {
      disableNotSelectedFeatureGroups(wizardActiveItem, wizardSelectedValues);
    }
    // it awkwardly jumps !! don't enable it
    // if (featureGroup && imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom) {
    //   const commonCoords = getCommonCoords(featureGroup, null, imageCanvas.current.canvas);
    //   const center = getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile);
    //   if (center) {
    //     imageCanvas.current.pinchZoom.zoomToCenter(center, 0, false, true);
    //     setCanvasScale(imageCanvas.current.pinchZoom.options.tapZoomFactor)
    //   }
    // }

    setGroheActiveFeatureQuantity(getNextWizardStepQuantity(currentGroups, wizardSelectedValues, wizardActiveStep));

    const nextActiveFeature = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature
      ? wizardSelectedValues[wizardActiveStep].selectedFeature
      : null;
    setLookActiveFeature(nextActiveFeature);

    updateLookCartItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep]);

  useUpdateMatchAllButton(currentGroups[0], featureGroup);

  useHideItemsDisabledfeatureGroups(wizardActiveItem, visualizersLoadedLength, wizardSelectedValues, updateLookCartItem);

  const disabled = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature
      && !isInStock(wizardSelectedValues[wizardActiveStep].selectedFeature)

  return (
    <div className={"lm-content lw-content" + (!IS_PRODUCT_JOURNEY && wizardActiveStep === -1 ? " lw-content--with-header" : "")}>
      <div className={"lw-content__thumbnail" + (IS_PRODUCT_JOURNEY ? " lw-content__thumbnail--product" : "")
        + (isCompletedStep ? " lw-content__thumbnail--completed" : "")}
           // style={wizardActiveStep === -1 ? {background: `url(${customImageUrl || uploadedImageUrl}) center / contain no-repeat`,} : null}
           ref={thumbnailRef}>
        <LookWizardContentCanvas imageCanvas={imageCanvas}/>
        {isMobile ? null : <LookWizardCompletedAlertModal anchorEl={thumbnailRef}/>}
      </div>
      <div className="lw-content__title">
        <LookWizardContentTitle/>
      </div>
      <div className="lw-content__description">
        <LookWizardContentDescription/>
      </div>
      <div className="lw-content__other">
        {featureGroup && featureGroup.activeFeature && featureGroup.allFeaturesReceived ? (
          <Fragment>
            <LookFeatureOptions isWizard={true}
                                wizardGroup={currentGroups[0]} />
            <GroheFeatureOptions isWizard={true}
                                 wizardGroup={currentGroups[0]}/>
          </Fragment>
        ) : null}
        {disabled ? (
          <GroheFeatureSoldOut disabled={disabled}/>
        ) : null}
        {/*{(!isCompletedStep || wizardActiveStep < 0) && (featureGroup && featureGroup.allFeaturesReceived)*/}
        {/*  ? <LookWizardContentMatch featureGroup={featureGroup}/>*/}
        {/*  : null}*/}
        {isCompletedStep ? <LookWizardContentFinalPrice/> : null}
      </div>
      {isMobile && !IS_PRODUCT_JOURNEY ? null : <LookWizardContentButtons/>}
    </div>
  )
};

LookWizardContent.propTypes = {
  updateLookCartItem: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {canvasCount} = store.bathroomVisualizerState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const {navigationCount} = store.lookState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    canvasCount,
    isMobile,
    navigationCount,
    setGroheActiveFeatureQuantity,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
  setCanvasScale,
  setLookActiveFeature,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardContent)
)
